import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './QRPlateSection.css';
import qrCodeMetallic from '../../../assets/qr.jpg';
import { convertFromMKD, getCurrencySymbol, isCurrencyPrefix } from '../../../utils/currency';

const QRPlateSection = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const currentLang = location.pathname.split('/')[1] || 'mk';

  return (
    <section className="qr-plate-section">
      <div className="qr-plate-container">
        <div className="product-card-minimal">
          {/* Left side - Image */}
          <div className="product-image-wrapper">
            <div className="premium-badge">
              {t('qrPlate.badge', 'Премиум')}
            </div>
            <img 
              src={qrCodeMetallic} 
              alt="Спомен.мк QR плочка" 
              className="product-image-minimal"
            />
          </div>
          
          {/* Right side - Info */}
          <div className="product-info-wrapper">
            <div className="product-header-minimal">
              <h3 className="product-title-minimal">
                {t('hero.product.title', 'Smart QR Плочка за Споменик')}
              </h3>
              <p className="product-subtitle">
                {t('qrPlate.description', 'Висококвалитетни QR плочки за вечни спомени')}
              </p>
            </div>

            <div className="price-wrapper">
              <div className="price-main">
                {isCurrencyPrefix(currentLang) ? (
                  <>
                    <span className="price-currency">{getCurrencySymbol(currentLang)}</span>
                    <span className="price-current">{convertFromMKD(1990, currentLang)}</span>
                  </>
                ) : (
                  <>
                    <span className="price-current">1.990</span>
                    <span className="price-currency">{getCurrencySymbol(currentLang)}</span>
                  </>
                )}
              </div>
              <p className="price-label">{t('hero.product.subtitle', 'Еднократно плаќање. Доживотен спомен.')}</p>
            </div>

            <Link to={`/${currentLang}/products`} className="cta-button-minimal">
              <svg className="button-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
              </svg>
              {t('hero.product.orderButton', 'Купи веднаш')}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default QRPlateSection; 